// on backend main the transfer expiration time is currently set to 5 seconds
// setting it a bit lower to avoid bad timing where the user clicks on accept
// and the transfer request expires just as the confirmation is transmitted to backend main
export const TRANSFER_EXPIRATION_IN_MINUTES = 4.9;
